import { useQuery } from '@apollo/react-hooks';
import GET_RESOURCE_EFFECTIVE_GRANTS from './getResourceEffectiveGrantsQuery.graphql';
import { isMissing } from 'Shared/utils';
import { GrantsType } from 'Shared/utils/auth';

export { GET_RESOURCE_EFFECTIVE_GRANTS };

export const useResourceEffectiveGrants = (
  resourceId: string,
  resourceType: string = 'policy'
) => {
  const { error, loading, data } = useQuery<{
    resourceEffectiveGrants: GrantsType;
  }>(GET_RESOURCE_EFFECTIVE_GRANTS, {
    errorPolicy: 'ignore',
    variables: {
      resourceId,
      resourceType,
    },
    skip: isMissing(resourceId),
    fetchPolicy: 'network-only',
  });

  return {
    error,
    loading,
    resourceEffectiveGrants: data?.resourceEffectiveGrants || [],
  };
};
